import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Title, OptionalLabel } from './FieldLabel.style'

interface FieldLabelProps {
  required?: boolean
  disableAdditionalLabel?: boolean
}

const FieldLabel: FC<FieldLabelProps> = ({
  required = true,
  disableAdditionalLabel,
  children,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Title {...props}>
      {children}&nbsp;
      {!disableAdditionalLabel &&
        (required ? '*' : <OptionalLabel>{t('optional')}</OptionalLabel>)}
    </Title>
  )
}

export default FieldLabel
